export const GROUP_BALANCES = `
  query groupBalances(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $orderBy: GroupBalanceOrderInput
    $filter: FilterGroupBalanceInput
    $searchText: String
  ) {
    groupBalances(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on GroupBalance {
        id
        group_id
        month
        members
        last_year_average_members
        last_year_drops
        last_year_adds
        last_year_retention
        year_to_date_average_members
        year_to_date_drops
        year_to_date_adds
        year_to_date_retention
        tier
        chair_id
        chair {
          id
          firstname
          lastname
        }
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

